<template>
  <div class="modules-settings-tenant-detail">

    <div class="nav-section">
      <a
        @click="navToTenantTab()"
        class="nav-back"
      >{{ $t('back') }}</a>
    </div>

    <div
      class="align-right action-bar"
      v-if="allowEdit"
    >
      <button
        type="button"
        class="btn btn--orange"
        @click="discardChange()"
        v-if="editView"
        v-hkldreset
      >{{ $t('action.cancel') }}</button>
      <button
        type="button"
        class="btn btn--orange"
        @click="editView = true"
        v-if="!editView"
      >{{ $t('action.edit') }}</button>
      <button
        type="button"
        class="btn btn--orange"
        @click="save()"
        v-if="editView"
        v-hkldreset
      >{{ $t('action.save') }}</button>
    </div>

    <div class="tenant-number">
      <label class="emphasis"> {{ $t('settings.user.tenant.number') }}: </label>
      <p>{{ tenantDetail.id }}</p>
    </div>
    <div class="contract-detail">
      <label class="emphasis sub-title">{{ $t('settings.user.vendor.companyDetail') }}</label>
      <div class="row">
        <div class="small-6 medium-6 large-6 columns">
          <p>{{ (tenantDetail || {}).name }}</p>
          <p>{{ (tenantDetail || {}).address1 }}</p>
          <p>{{ (tenantDetail || {}).address2 }}</p>
          <p>{{ (tenantDetail || {}).address3 }}</p>
          <p>{{ (tenantDetail || {}).address4 }}</p>
        </div>
        <div>
          <input
            type="checkbox"
            id="settings-users-tenant-company-name-update"
            :disabled="!editView"
            :class="{ 'disabled': !editView }"
            v-model="specialHandled"
            v-hkldinput
          >
          <label for="settings-users-tenant-company-name-update">{{ $t('settings.user.vendor.combineName') }}</label>
        </div>
      </div>
      <label class="emphasis"> {{ $t('settings.user.vendor.phone') }}</label>
      <p>{{ (tenantDetail || {}).phone || '--' }}</p>
      <label class="emphasis"> {{ $t('company.contact.fax') }}</label>
      <p>{{ (tenantDetail || {}).fax || '--' }}</p>
    </div>
  </div>
</template>

<script>
import * as accountsRequest from '@/api/accounts/request'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { aclHelper } from '@/utils/aclHelper'

export default {
  name: 'tenantDetail',
  data () {
    return {
      accountInfo: {},
      tenantDetail: {},
      specialHandled: false,
      editView: false,
    }
  },
  methods: {
    discardChange () {
      fusionInputCheckUtil.resetAllFields()
      this.specialHandled = this.tenantDetail.specialHandled
      this.editView = false
    },

    async initPage () {
      const id = this.$router.currentRoute.params.id
      const tenantInfo = await accountsRequest.getAccountById(id) || {}
      this.tenantDetail = tenantInfo.company
      this.specialHandled = this.tenantDetail.specialHandled
      this.keep = JSON.parse(JSON.stringify(this.tenantDetail))
    },

    async save () {
      if (this.specialHandled !== this.tenantDetail.specialHandled) {
        await accountsRequest.handleSpecialName(this.tenantDetail.id, this.tenantDetail.type, this.specialHandled)
      }
      await this.initPage()
      this.editView = false
    },

    navToTenantTab () {
      this.$router.push({
        name: 'all-tenants',
      })
    },
  },

  async mounted () {
    await this.initPage()
  },

  computed: {
    allowEdit () {
      return aclHelper.getSettingsUpdateAccess()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';

.contract-detail {
  padding: 20px 24px 24px;
  label {
    margin-top: 8px;
    margin-bottom: 0;
  }
  input {
    margin-bottom: 10px;
  }
}

.invited-at {
  float: left;
  margin-left: 24px;
}

.modules-settings-tenant-detail {
  .align-right {
    padding: 10px 0;
  }
}
.actions {
  display: block;
}
.action-bar {
  text-align: right;
  margin: 0 20px;
  .btn {
    margin-left: 15px;
  }
}

.disabled, .disabled + label[for] {
  cursor: default;
}

.nav-section{
  padding: 10px 24px;
  border-bottom: 1px solid #e0e0e0;
  a {
    padding-left: 0;
    font-size: 14px;
  }
}

.tenant-number {
  margin-left: 24px;
  label {
    margin-top: 0;
  }
}
</style>
